// Müştəri idxalı (KT-49): sətir üçün defolt seçim və icazə verilən seçimlər.
import type { CustomerImportAction, CustomerImportRow } from '@kassa/shared';

export function defaultAction(row: Pick<CustomerImportRow, 'errors' | 'match'>): CustomerImportAction {
  if (row.errors.length > 0) return 'skip';
  return row.match ? 'update' : 'create';
}

export function allowedActions(row: Pick<CustomerImportRow, 'errors' | 'match'>): CustomerImportAction[] {
  if (row.errors.length > 0) return ['skip'];
  return row.match ? ['update', 'skip'] : ['create', 'skip'];
}

export const ACTION_LABEL: Record<CustomerImportAction, string> = {
  create: 'Yarat',
  update: 'Yenilə',
  skip: 'Keç',
};
